/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Phase2_Fix_Price_Flat_NoteInputs */

const en_phase2_fix_price_flat_note = /** @type {(inputs: Phase2_Fix_Price_Flat_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`flat`)
};

const zh_hans1_phase2_fix_price_flat_note = /** @type {(inputs: Phase2_Fix_Price_Flat_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`固定价`)
};

const pt_br2_phase2_fix_price_flat_note = /** @type {(inputs: Phase2_Fix_Price_Flat_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`preço fixo`)
};

const es_phase2_fix_price_flat_note = /** @type {(inputs: Phase2_Fix_Price_Flat_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`tarifa fija`)
};

const fr_phase2_fix_price_flat_note = /** @type {(inputs: Phase2_Fix_Price_Flat_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`forfait fixe`)
};

const de_phase2_fix_price_flat_note = /** @type {(inputs: Phase2_Fix_Price_Flat_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pauschal`)
};

const ru_phase2_fix_price_flat_note = /** @type {(inputs: Phase2_Fix_Price_Flat_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`фиксированная`)
};

const it_phase2_fix_price_flat_note = /** @type {(inputs: Phase2_Fix_Price_Flat_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`fisso`)
};

/**
* | output |
* | --- |
* | "flat" |
*
* @param {Phase2_Fix_Price_Flat_NoteInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const phase2_fix_price_flat_note = /** @type {((inputs?: Phase2_Fix_Price_Flat_NoteInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Phase2_Fix_Price_Flat_NoteInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_phase2_fix_price_flat_note(inputs)
	if (locale === "pt-BR") return pt_br2_phase2_fix_price_flat_note(inputs)
	if (locale === "es") return es_phase2_fix_price_flat_note(inputs)
	if (locale === "fr") return fr_phase2_fix_price_flat_note(inputs)
	if (locale === "de") return de_phase2_fix_price_flat_note(inputs)
	if (locale === "ru") return ru_phase2_fix_price_flat_note(inputs)
	if (locale === "it") return it_phase2_fix_price_flat_note(inputs)
	return en_phase2_fix_price_flat_note(inputs)
});